export default "__VITE_ASSET__d588e885__"